import PaymentService from "../../Services/PaymentService";

export const FETCH_PAYMENTS_REQUEST = "FETCH_PAYMENTS_REQUEST";
export const FETCH_PAYMENTS_SUCCESS = "FETCH_PAYMENTS_SUCCESS";
export const FETCH_PAYMENTS_FAILURE = "FETCH_PAYMENTS_FAILURE";

export const FETCH_PAYMENTS_COUNT_REQUEST = "FETCH_PAYMENTS_COUNT_REQUEST";
export const FETCH_PAYMENTS_COUNT_SUCCESS = "FETCH_PAYMENTS_COUNT_SUCCESS";
export const FETCH_PAYMENTS_COUNT_FAILURE = "FETCH_PAYMENTS_COUNT_FAILURE";

export const FETCH_BILLING_REPORT_REQUEST = "FETCH_BILLING_REPORT_REQUEST";
export const FETCH_BILLING_REPORT_SUCCESS = "FETCH_BILLING_REPORT_SUCCESS";
export const FETCH_BILLING_REPORT_FAILURE = "FETCH_BILLING_REPORT_FAILURE";

export const FETCH_BILLING_REPORT_COUNT_REQUEST = "FETCH_BILLING_REPORT_COUNT_REQUEST";
export const FETCH_BILLING_REPORT_COUNT_SUCCESS = "FETCH_BILLING_REPORT_COUNT_SUCCESS";
export const FETCH_BILLING_REPORT_COUNT_FAILURE = "FETCH_BILLING_REPORT_COUNT_FAILURE";


export const fetchPayments = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENTS_REQUEST });
  try {
    const response = await PaymentService.getBillingTransaction(payload);
    dispatch({ type: FETCH_PAYMENTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PAYMENTS_FAILURE, payload: error.message });
  }
};

export const fetchPaymentsCount = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENTS_COUNT_REQUEST });

  try {
    const response = await PaymentService.getBillingCount(payload);
    dispatch({
      type: FETCH_PAYMENTS_COUNT_SUCCESS,
      payload: response.data.TOTAL_COUNT_STATUS,
    });
  } catch (error) {
    dispatch({ type: FETCH_PAYMENTS_COUNT_FAILURE, payload: error.message });
  }
};

export const fetchBillingReport = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_BILLING_REPORT_REQUEST });

  try {
    const response = await PaymentService.getBillingTransaction(payload);
    dispatch({type: FETCH_BILLING_REPORT_SUCCESS,payload: response.data});
  } catch (error) {
    dispatch({type: FETCH_BILLING_REPORT_FAILURE,payload: error.message});
  }
};

export const fetchBillingReportCount = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_BILLING_REPORT_COUNT_REQUEST });

  try {
    const response = await PaymentService.getBillingCount(payload);
    dispatch({
      type: FETCH_BILLING_REPORT_COUNT_SUCCESS,
      payload: response.data.TOTAL_COUNT_STATUS,
    });
  } catch (error) {
    dispatch({ type: FETCH_BILLING_REPORT_COUNT_FAILURE, payload: error.message });
  }
};

